import firebase from "firebase";
import WelcomeEmailStyle from "../store/emailStyle.js";
import { create } from "lodash";

export default {
  state: {
    emailStyle: WelcomeEmailStyle.style,
    bodyTableWrapper: WelcomeEmailStyle.bodyTableWrapper,
    bodyTableEnd: WelcomeEmailStyle.bodyTableEnd,
  },
  getters: {
    emailStyle: (state) => state.emailStyle,
    emailBodyTableWrapper: (state) => state.bodyTableWrapper,
    emailBodyTableEnd: (state) => state.bodyTableEnd,
  },
  mutations: {},
  actions: {
    sendMail: function (context, payload) {
      let mailObj = {};
      mailObj.to = payload.to;
      if (payload.bcc) {
        mailObj.bcc = payload.bcc;
      }
      if (payload.cc) {
        mailObj.cc = payload.cc;
      }
      mailObj.message = {
        subject: payload.subject,
        html: payload.html,
      };
      firebase
        .firestore()
        .collection("mail")
        .add(mailObj)
        .then(console.log("sent mailObj ", mailObj));
    },
    mailerSend: function (context, mailObj) {
      const defaultRecipients = [
        { email: "tomavey@outlook.com", name: "Tom Avey" },
      ];
      let recipients = defaultRecipients;
      if (mailObj.to?.length) {
        recipients = mailObj.to.map((entry) =>
          typeof entry === "string"
            ? { email: entry, name: entry.split("@")[0] }
            : entry,
        );
      }

      const sendObj = {
        to: recipients,
        from: {
          email: "support@everhost.io",
        },
        subject: mailObj.subject || "Everhost Notification",
        html: mailObj.html,
        reply_to: mailObj.reply_to || { email: "tomavey@outlook.com" },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      return firebase
        .firestore()
        .collection("emails")
        .add(sendObj)
        .then(() => {
          console.log("sent sendObj ", sendObj);
        });
    },
  },
};
